export const reviewsStatisticsPhotosBlock = 'reviews-statistics-photos-block';
export const starCountVisualizerFill = 'star-count-visualizer-fill';
export const starCountVisualizerBg = 'star-count-visualizer-bg';
export const starRatingSnapshotBlock = 'star-rating-snapshot-block';
export const starRatingSnapshotBlockValue = 'star-rating-snapshot-block-value';
export const starRatingSnapshotBlockCount = 'star-rating-snapshot-block-count';
export const starRatingSnapshotBlockVisualizer = 'star-rating-snapshot-block-visualizer';
export const averageRatingReviewsCount = 'average-rating-reviews-count';
export const averageRatingCta = 'average-rating-cta';
export const averageRatingReviewlet = 'average-rating-reviewlet';
export const writeReviewDoAgree = 'write-review-do-agree';
export const writeReviewSubmitButton = 'write-review-submit-button';
export const writeReviewOpenWritingGuidelines = 'write-review-open-writing-guidelines';
export const writeReviewOpenPhotoGuidelines = 'write-review-open-photo-guidelines';
